import { render, staticRenderFns } from "./Caixas.vue?vue&type=template&id=c1880fcc&scoped=true"
import script from "./Caixas.vue?vue&type=script&lang=js"
export * from "./Caixas.vue?vue&type=script&lang=js"
import style0 from "./Caixas.vue?vue&type=style&index=0&id=c1880fcc&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1880fcc",
  null
  
)

export default component.exports